import type { FC } from "react";

import type { OAuthClientResponse } from "../../api/oauth";
import { AppCard, AppCardPlaceholder } from "./AppCard";

interface GridProps {
  apps: Array<OAuthClientResponse | { placeholder?: boolean }>;
}

export const AppPageGrid: FC<GridProps> = ({ apps }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
    {apps.map((app) => (
      <div
        key={"client_id" in app ? app.client_id : "submit-placeholder"}
        className="animation-item"
      >
        {"placeholder" in app ? (
          <AppCardPlaceholder />
        ) : (
          <AppCard {...(app as OAuthClientResponse)} />
        )}
      </div>
    ))}
  </div>
);
